Ext.define('SA.lq.view.ConditionsPanel', {
    alias: 'widget.lq-conditions-panel',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-lq-conditions-panel',

    items: [
        {
            xtype: 'component',
            cls: 'sa-lq-conditions-panel-heading',
            html: 'Conditions'
        }, {
            xtype: 'simple-container',
            itemId: 'conditionList',
            cls: 'sa-lq-conditions-panel-condition-list'
        }, {
            xtype: 'component',
            cls: 'sa-lq-conditions-panel-condition-placeholder',
            html: 'Add a variable from the left<br>(optional)'
        }, {
            xtype: 'simple-container',
            cls: 'sa-lq-conditions-panel-search-btn-container',

            items: [
                {
                    xtype: 'sa-button',
                    cls: 'sa-lq-conditions-panel-search-btn',
                    itemId: 'searchBtn',
                    text: 'Search',
                    ui: 'primary'
                }
            ]
        }
    ]
});